module.exports = __webpack_public_path__ + "img/r.8a44e034.png";